import { ComponentConfig } from "@zapier/builder.io-kit";
import dynamic from "next/dynamic";

export const taskSelectorConfig: ComponentConfig = {
  name: "TaskSelector",
  category: "Pricing",
  component: dynamic(() => import("./TaskSelector")),
  canHaveChildren: true,
  inputs: [
    {
      name: "stateKey",
      type: "string",
      required: true,
      helperText:
        "An identifier that should match any other component(s) on the page that should be updated by interactions with this component.",
    },
    {
      name: "title",
      type: "string",
      helperText: "Displayed when the selected number of tasks is 0.",
    },
    {
      name: "customTaskLimitTooltip",
      type: "richText",
      helperText:
        "Displayed on the slider (on desktop) when 'Custom Task Limit' is selected.",
    },
    {
      name: "taskTiers",
      type: "list",
      required: true,
      helperText:
        "Task tiers define the steps on the slider (on desktop) and the options in the dropdown (on mobile).",
      defaultValue: [],
      subFields: [
        {
          name: "label",
          type: "string",
          required: true,
          helperText:
            "The label shown next to tick marks on the slider (on desktop) and as part of text shown for each dropdown option (on mobile). For example, if the label is '2m', it will show as '2m tasks /mo' in the dropdown.",
        },
        {
          name: "numberOfTasks",
          type: "number",
        },
        {
          name: "showLabel",
          friendlyName: "Show label on slider?",
          type: "boolean",
          defaultValue: true,
          helperText:
            "Should the label be shown next to the tick mark for this tier? Labels are always shown in the dropdown (on mobile).",
        },
      ],
    },
  ],
};
